export const environment = {
  production: false,
  apiUrl: 'https://dev.api.privaci.io/api',
  // The customer app origin, for the sign-in's "Back to the customer app" link.
  appUrl: 'https://dev.app.privaci.io',
  // This is what deployed dev builds and `ng serve` use. For local full-stack work, run
  // `ng serve --configuration local`, which swaps in environment.local.ts.
};
